var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 14.6666C23.6593 14.6666 24.9311 15.1934 25.8688 16.1311C26.8065 17.0688 27.3333 18.3405 27.3333 19.6666V25.5H23.9999V19.6666C23.9999 19.2246 23.8243 18.8007 23.5118 18.4881C23.1992 18.1756 22.7753 18 22.3333 18C21.8912 18 21.4673 18.1756 21.1547 18.4881C20.8422 18.8007 20.6666 19.2246 20.6666 19.6666V25.5H17.3333V19.6666C17.3333 18.3405 17.86 17.0688 18.7977 16.1311C19.7354 15.1934 21.0072 14.6666 22.3333 14.6666Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 15.5H10.6667V25.5H14.0001V15.5Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 13C13.2539 13 14.0001 12.2538 14.0001 11.3333C14.0001 10.4128 13.2539 9.66663 12.3334 9.66663C11.4129 9.66663 10.6667 10.4128 10.6667 11.3333C10.6667 12.2538 11.4129 13 12.3334 13Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo-linkedin.6181621b03cffba67732042f92b077c5.svg";
export { ForwardRef as ReactComponent };